export const primitives = {
  colors: {
    prBlueOne: 'var(--pr-blue-1)',
    prBlueTwo: 'var(--pr-blue-2)',
    prBlueThree: 'var(--pr-blue-3)',

    darkBlueOne: 'var(--dark-blue-1)',
    darkBlueTwo: 'var(--dark-blue-2)',

    bgBlueTwo: 'var(--bg-blue-2)',
    bgBlueThree: 'var(--bg-blue-3)',

    greyOne: 'var(--grey-1)',
    greyTwo: 'var(--grey-2)',
    greyThree: 'var(--grey-3)',
    greyOutline: 'var(--grey-outline)',
    white: 'var(--white)',

    greenOne: 'var(--green-1)',
    greenTwo: 'var(--green-2)',
    greenThree: 'var(--green-3)',

    redOne: 'var(--red-1)',
    redTwo: 'var(--red-2)',
    redThree: 'var(--red-3)',

    yellowOne: 'var(--yellow-1)',
    yellowTwo: 'var(--yellow-2)',

    greenOneAlt: 'var(--green-1-alt)',
    greenTwoAlt: 'var(--green-2-alt)',
    blueOne: 'var(--blue-1)',
    blueTwo: 'var(--blue-2)',

    greenOneBg: 'var(--green-1-bg)',
    greenTwoBg: 'var(--green-2-bg)',
    blueOneBg: 'var(--blue-1-bg)',
    blueTwoBg: 'var(--blue-2-bg)',
    transparent: 'transparent',
  },
  fontWeights: {
    regular: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
  },
};
